module.exports = __webpack_public_path__ + "img/angular.1a632d2b.jpg";